var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-page-header',{attrs:{"content":"数据导出"},on:{"back":function($event){return _vm.$router.go(-1)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }